export default __webpack_public_path__ + "static/media/metal.83b66fab.jp2";